import type { ReactNode } from "react";

export function WIPPanel({
  icon,
  title,
  description,
}: {
  icon: ReactNode;
  title: string;
  description: string;
}) {
  return (
    <div className="wip-panel">
      <div className="wip-icon">{icon}</div>
      <span className="wip-badge">Work in progress</span>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
}
